import { Notification, Badge } from "@transfr-inc/dashboard-components";
import { AwardItem } from "./award-item.component";

export const LearnerAwardsSlide = ({
  awards,
  notification,
  onNotificationClose,
  onAwardSelected,
}) => {
  return (
    <div className="learner-awards-slide">
      {notification && (
        <Notification
          type={notification.type}
          icon={notification.icon}
          closable
          onClose={onNotificationClose}
        >
          {notification.message}
        </Notification>
      )}
      <div className="header-container">
        <h3>Credentials</h3>
        {awards && <Badge value={awards.length}></Badge>}
      </div>
      {awards && awards.length > 0 ? (
        <>
          <span className="flavor-text">
            * Credentials will open in a new browser tab.
          </span>
          <div className="export-awards-modal-content">
            <div className="modal-body-list-container">
              <div>
                {awards?.map((award) => (
                  <AwardItem
                    key={award.credentialId}
                    award={award}
                    onClick={onAwardSelected}
                  />
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="no-awards-container">
          <div className="no-awards-content">
            <span>
              You haven't earned any credentials in this classroom yet.
            </span>
          </div>
        </div>
      )}
    </div>
  );
};